import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    if (typeof console !== "undefined" && console.error) {
      console.error("Application error:", error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            padding: "2rem",
            maxWidth: 640,
            margin: "2rem auto",
            fontFamily: "system-ui, sans-serif",
            color: "#1a202c",
          }}
        >
          <h2 style={{ margin: "0 0 1rem", fontSize: "1.25rem" }}>Something went wrong</h2>
          <p style={{ margin: "0 0 1rem", color: "#4a5568", lineHeight: 1.5 }}>
            {this.state.error?.message || "An unexpected error occurred. Please refresh the page and try again."}
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{
              padding: "10px 18px",
              borderRadius: 8,
              border: "none",
              background: "#8b1634",
              color: "#fff",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Reload page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
